import React, { useContext } from "react";
import RootContext from "../../../context/RootContext";
import { shuffleArray } from "../../../utils/shuffleArray";
import { getHotelsOrPagesFromIds } from "../../../utils/logic/getHotelsOrPagesFromIds";
import { checkFeaturedPageIds } from "../../../utils/checkFeaturedPageIds";
import AdditionalCards from "../Cards/AdditionalCards";

const PageContentParentChild = ({
  section,
  pillar,
  resultsPillarObject,
  placeholderImage,
  hotelIdsFeaturedOnPage,
}) => {
  const { allPillarPages } = useContext(RootContext);
  let selectedPages;
  // If option is not manual then we automatically get AdditionalCards - get all pillar pages

  // If slug or parent page matches pillarPages slug or current page
  let currentParentSlug = pillar.parentPage
    ? pillar.parentPage.slug.current
    : null;
  if (currentParentSlug) {
  }
  let currentSlug = pillar.slug.current;

  let pillarPages = allPillarPages.filter((element) => {
    // if id does not match current page
    if (element._id !== pillar._id) {
      /** IF there is currentParentSlug and elementParentSlug -
       *  check parents match and push
       * 	ELSE
       * 	check currentParent against elementSlug
       * ELSE IF there is no currentParent
       * IF there is a elementParent
       *  check currentSlug	matches elementParent
       *  ELSE
       *  check currentSlug matches elementSlug
       */
      if (
        currentParentSlug &&
        element.parentPage &&
        currentParentSlug === element.parentPage.slug.current
      )
        return element;
      if (currentParentSlug && currentParentSlug === element.slug.current)
        return element;
      if (element.parentPage && currentSlug === element.parentPage.slug.current)
        return element;
      if (currentSlug === element.slug.current) return element;
    }
    return element;
  });

  // FOLLOW UP: DO I NEED TO SHUFFLE THESE?
  if (section.pageDisplay === "auto") {
    // Shuffle Pillar Pages
    selectedPages = shuffleArray(pillarPages);
  }
  if (section.pageDisplay === "manual") {
    // If option is manual and pages are added by user
    selectedPages = section.pages.map((page) => page._id);
    // Get pages from ids and shuffle Array
    selectedPages = shuffleArray(
      getHotelsOrPagesFromIds(pillarPages, selectedPages)
    );
  }

  // check to see if any ids are already in hotelIdsFeaturedOnPage
  selectedPages = checkFeaturedPageIds(selectedPages, hotelIdsFeaturedOnPage);
  // Pass in to Cards
  return (
    <AdditionalCards
      sectionType={section._type}
      key={section._key}
      cardsType="parentChildPages"
      resultsType={resultsPillarObject}
      allPages={selectedPages}
      placeholderImage={placeholderImage}
    />
  );
};

export default PageContentParentChild;
